import { render, staticRenderFns } from "./BoardSettingsGeneral.vue?vue&type=template&id=54fa0cda&scoped=true&lang=pug&"
import script from "./BoardSettingsGeneral.vue?vue&type=script&lang=js&"
export * from "./BoardSettingsGeneral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54fa0cda",
  null
  
)

export default component.exports